var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.getTableColTitles,"items":_vm.data,"hide-default-footer":_vm.isFooterHidden,"mobile-breakpoint":_vm.mobileBreakpoint},on:{"click:row":function($event){return _vm.openItem($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }